<template>
  <div class="fb-layout-wrapper" :id="element.uuid">
    <component
      v-for="(el, index) in element.list"
      :uuid="el.uuid"
      :nid="nid"
      :sid="sid"
      :main_sid="main_sid"
      :key="el.uuid"
      :is="el.type"
      :element="el"
      :mode="1"
      :validate="validate"
      :active="active"
      :step="element.uuid"
      :countFormCards="countFormCards"
      :is-draft="isDraft"
      :status="status"
      :showSubmit="showSubmit"
      :validationFails="validation"
      @submit="$emit('submit')"
      @validation="updateValidation(index, $event)"
      @validate-form="$emit('validate-form')"
      @disable-form-validation="$emit('disable-form-validation')"
      @submit-draft="$emit('submit-draft', $event)"
      @autosave-start="$emit('autosave-start')"
      @autosave-stop="$emit('autosave-stop')"
      @set-value="$emit('set-value', $event)"
    ></component>
  </div>
</template>

<script>
import FbStep from "./FbStep.vue";

export default {
  name: "FbWrapper",
  props: [
    "element",
    "mode",
    "stepIndex",
    "steps",
    "active",
    "validate-last-step",
    "countFormCards",
    "status",
    "showSubmit",
    "validate",
  ],
  mixins: [FbStep],
  computed: {
    valid: {
      cache: false,
      get() {
        if (this.isDraft) {
          return true;
        }
        let errors = this.validation.filter(el => {
          return el !== true;
        });
        return errors.length == 0;
      }
    }
  },
  created() {
    this.$emit("validation", this.valid);
  },
  data() {
    return {
      // validate: false,
      validation: [],
      list: this.element.list || []
    };
  },
  methods: {
    log(e) {
      console.log(e);
    },
    updateValidation(index, event) {
      this.validation[index] = event;
      this.validation = this.validation.slice(0);
      this.$emit("validation", this.valid);
    }
  }
};
</script>

<style lang="scss" scoped>
.fb-layout-wrapper {
  margin-left: -10px;
  margin-right: -10px;
}
</style>
